<!--
 * @Description: 财务对账页面
 * @Author: sunhuihong
 * @Date: 2022-07-31 16:43:52
 * @LastEditTime: 2022-12-15 13:27:44
-->
<template>
   <div class="body">
    <el-row style="margin: 25px 40px;" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="8" style="text-align: left;">
				<span class="search-title">机构名称:  </span>
				<el-select v-model="filterParams.institutionId" clearable filterable size="small"  placeholder="请输入/选择"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)" 
          style="width: 240px;" >
					<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-col>
      <el-col :span="8" >
				<span class="search-title">编号:  </span>
				<el-input v-model="filterParams.orderNoOrTransactionNo" size="small" clearable style="width: 240px;"
					placeholder="请输入订单编号 / 交易流水编号"></el-input>
			</el-col>
			<el-col :span="8" style="text-align: right;">
				<span class="search-title">交易时间:  </span>
				<el-date-picker v-model="dateRange" style="width: 240px;" type="daterange" align="right"
					unlink-panels range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
					:picker-options="dateRangePickerOptions" size="small">
				</el-date-picker>
			</el-col>
    </el-row>
    <el-row class="bk-search" style="margin: 25px 40px;" :gutter="0" type="flex" justify="space-between" align="middle">
			<el-col :span="12" style="text-align: left;">
				<span class="search-title">记录类型:  </span>
				<el-checkbox-group  v-model="filterRecTypeList" :min="0" :max="2" style="display: inline-block">
          <el-checkbox v-for="(item, index) in statementRecordTypeList" :key="index" :label="parseInt(item.key)">
						{{item.value}}
					</el-checkbox>
        </el-checkbox-group>
			</el-col>
      <el-col  :span="12" style="text-align: right;">
        <el-button size="small"  @click="handleQuery" type="primary"  icon="el-icon-search" style="width: 80px;">
          搜 索
        </el-button>
        <el-button v-if="dataPvgList.includes('INCOME_1_BALANCE')"  size="small"  @click="handleBalanceAccounts" type="primary" plain style="width: 80px;">
          <img style="width: 14px; height: 14px; vertical-align: text-bottom;" src="../../assets/common/icon-common-statement.png" alt="">
          <span style="margin-left: 4px; font-size: 12px;">平 账</span>
        </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 0 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable" 
      :header-cell-style="{ 'background-color':'#EFF5FA'}">
        <el-table-column label="交易流水编号" min-width="10%" align="left">
          <template slot-scope="scope">
            <el-popover v-if="scope.row.transactionNo.length > 23" placement="bottom" title="" width="150" trigger="hover" >
              <span>{{scope.row.transactionNo}}</span>
              <span slot="reference" class="overflow-text-style" style="cursor: pointer;">
                {{scope.row.transactionNo}}
              </span>
            </el-popover>
            <span v-else>
              {{ scope.row.transactionNo ? scope.row.transactionNo : '- -'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column  label="订单编号" min-width="12%"  align="left">
				  <template slot-scope="scope">
				  	<span :class="scope.row.orderNo == '' || scope.row.orderNo == null ? '' : 'cursor-style'" 
              :style="{color: scope.row.orderNo == '' || scope.row.orderNo == null ? '#606266' : '#3E7EF5'}"
              @click="handleOrderDetailsClick(scope.row)">
              {{scope.row.orderNo == '' || scope.row.orderNo == null ? '- -' : scope.row.orderNo}}
            </span>
				  </template>	
        </el-table-column>
        <el-table-column prop="amountYuan" label="金额(元)" min-width="8%" align="left"></el-table-column>
        <el-table-column prop="institutionName" label="机构名称"  min-width="12%"  align="left"> </el-table-column>
        <el-table-column  label="交易类型"  min-width="9%"  align="left">
          <template slot-scope="scope">
            <span>{{scope.row.transactionTypeTxt == '' || scope.row.transactionTypeTxt == null ? '- -' : scope.row.transactionTypeTxt}}</span>
          </template>
        </el-table-column>
        <el-table-column  label="支付方式"  min-width="9%"  align="left">
          <template slot-scope="scope">
            <span class="overflow-text-style">
              {{scope.row.paywayTxt == '' || scope.row.paywayTxt == null ? '- -' : scope.row.paywayTxt}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="recTypeTxt" label="记录类型"  min-width="9%" align="left"></el-table-column>
        <el-table-column  label="说明"  min-width="15%" align="left">
          <template slot-scope="scope" >
            <el-popover v-if="scope.row.remark.length > 20" placement="bottom" title="" width="250" trigger="hover" >
              <span>{{scope.row.remark}}</span>
              <span slot="reference" class="overflow-text-style" style="cursor: pointer;">
                {{scope.row.remark}}
              </span>
            </el-popover>
            <span v-else>{{scope.row.remark}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="transactionTime" label="交易时间" sortable min-width="12%"  align="left">
          <template slot-scope="scope">
            {{scope.row.transactionTime == '' || scope.row.transactionTime == null ? '- -' : rebuildDate(scope.row.transactionTime)}}
          </template>
        </el-table-column>
        <el-table-column  label="操作" min-width="6%"  align="left">
          <template slot-scope="scope">
            <el-button v-for="(item,index) in scope.row.buttonDesList" :key="index" type="text" size="small"
              @click="handleEditStatementItem(item, scope.row)">
              {{item}}
            </el-button>
          </template>
        </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
    </el-row>

    <!-- 平账弹框 -->
    <balance-account :visible="showBalanceAccountDialog" :operate="operate" :balanceId="balanceId" @close-dialog="closeBalanceAccountDialog"/>

    <!-- 订单详情弹框 -->
		<order-details-dialog :visible="showOrderDialog" @check-collectdetails="handleSeeCollectDetails"
			@close-dialog="closeOrderDialog" :orderId="orderId" />

    <!--评估收款详情 -->
		<payment-details-dialog :visible="showCollectMoneyDialog" @close-dialog="closePaymentDialog" :orderId="orderId" />
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import BalanceAccount from './components/statementlist/BalanceAccount.vue'
import OrderDetails from '../ordermng/components/OrderDetails.vue'
import PaymentDetails from '../ordermng/components/PaymentDetails.vue'

export default {
  name: 'StatementList',
  
  components: {
    'balance-account': BalanceAccount,
    'order-details-dialog': OrderDetails,
    'payment-details-dialog': PaymentDetails,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
				begDate: null,
				endDate: null,
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
      institutionList: [],
      srcInstitutionList: [],
      statementRecordTypeList: [],//记录类型数据
      filterRecTypeList: [],
			dateRange: null,
			dateRangePickerOptions: this.dateUtil.getDateRangePickerOptions(true, false),
      recTypeList: [],
      dataTable: [],
      showBalanceAccountDialog: false,
      operate: '',
      balanceId: '',
      showOrderDialog: false,//是否显示订单详情页面
      orderId: '',
      showCollectMoneyDialog: false,//评估收款详情dialog变量
    }
  },
  
  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },

  methods:{
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getFilterDo();
      await this.listStatements();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'INCOME'},
			  };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
			  })
		  })
    },

    //过滤条件接口调用
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_STATEMENT_FILTER_DO).then(result => {
          if (result != null) {
            this.statementRecordTypeList = this.commonUtil.map2List(result.data.statusMap);
            this.institutionList = result.data.simpleInstitutionList;
            this.srcInstitutionList = result.data.simpleInstitutionList;
            resolve();
          }
        })
      })
    },

    //财务对账list接口调用
    listStatements() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_STATEMENTS,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },

    //搜索
    handleQuery() {
			this.filterParams.begDate = !this.dateRange ? null : this.dateUtil.dateFormat(this.dateRange[0]);
			this.filterParams.endDate = !this.dateRange ? null : this.dateUtil.dateFormat(this.dateRange[1]);
			this.filterParams.recTypeList = this.filterRecTypeList.length ? this.filterRecTypeList.join(",") : '';
			this.filterParams.page = 1;
			this.listStatements();
    },
    
    //点击订单编号调转订单详情
    handleOrderDetailsClick(data) {
      if(data.recType == 2) return;
      this.queryOrderId(data.orderNo);
    },

    //根据订单编号查询订单id
    queryOrderId(orderNo) {
      let params = {no: orderNo};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_ORDER_DETAILS_OF_NO,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if(result !== null){
          this.orderId = result.data.order.id;
          this.showOrderDialog = true;
        }
      });
    },

		//查看评估详情
		handleSeeCollectDetails() {
			this.showCollectMoneyDialog = true;
		},
		
		closeOrderDialog() {
			this.showOrderDialog = false;
		},

		//关闭评估收款详情对话框
		closePaymentDialog() {
			this.showCollectMoneyDialog = false;
		},

    //新增（点击平账）
    handleBalanceAccounts() {
      this.operate = 'add';
      this.showBalanceAccountDialog = true;
    },

    //编辑
    handleEditStatementItem(item,data) {
      if(item == '编辑') {
        this.operate = 'edit';
        this.showBalanceAccountDialog = true;
        this.balanceId = data.id;
      }
    },
    
    //关闭平账弹框
    closeBalanceAccountDialog(refresh) {
      this.showBalanceAccountDialog = false;
      if (refresh) {
				this.listStatements();
			}
    },

    //以下是分页控件
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listStatements();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listStatements();
    },

    rebuildDate(date) {
      return this.dateUtil.dateTimeFormat(date);
    },

  },

  mounted() {
    this.$emit("breadcrumb", {text1: '财务管理', text2: '财务对账'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  margin-right: 9px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
  margin: 15px 0 ;
}

.foot-pagination {
  margin-top: 57px;
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.cursor-style {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.overflow-text-style {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/StatementList.vue